import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../api/axios";
import loadStatus from "../util/loadStatus";

export const getTaskStatuses = createAsyncThunk(
  "taskStatuses/getTaskStatuses",
  async (reqData, { rejectWithValue, getState }) => {
    try {
      const state = getState().taskStatuses;
      if (state.data.length <= 0 && state.count.getTaskStatuses <= 1) {
        const res = await axios.get("/task-statuses");
        return res.data;
      }
      return state.data;
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data);
      }

      return rejectWithValue(error.message);
    }
  }
);

export const addTaskStatuses = createAsyncThunk(
  "taskStatuses/addTaskStatuses",
  async ({ id, reqData }, { rejectWithValue }) => {
    try {
      const res = await axios.post(`/add-task-status/${id}`, reqData);
      return res.data;
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data);
      }

      return rejectWithValue(error.message);
    }
  }
);

export const editTaskStatuses = createAsyncThunk(
  "taskStatuses/editTaskStatuses",
  async (id, { rejectWithValue }) => {
    try {
      const res = await axios.put(`/edit-task-status/${id}`);
      return res.data;
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data);
      }

      return rejectWithValue(error.message);
    }
  }
);

export const deleteTaskStatuses = createAsyncThunk(
  "taskStatuses/deleteTaskStatuses",
  async ({ id, reqData }, { rejectWithValue }) => {
    try {
      const res = await axios.delete(`/delete-task-status/${id}`, reqData);
      return res.data;
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data);
      }

      return rejectWithValue(error.message);
    }
  }
);

const taskStatusesSlice = createSlice({
  name: "taskStatuses",
  initialState: {
    data: [],
    selected: {},
    loading: false,
    error: null,
    count: { getTaskStatuses: 0, getTaskStatus: 0 },
  },
  reducers: {
    setTaskStatuses: (state, action) => {
      state.data = action.payload;
    },
    setSelectedTaskStatuses: (state, action) => {
      state.selected = action.payload;
    },
    unsetTaskStatuses: (state) => {
      state.data = [];
      state.selected = {};
    },
  },
  extraReducers: (builder) => {
    builder
      //Get all Tasks
      .addCase(getTaskStatuses.pending, (state) => {
        state.loading = loadStatus.loading;
        state.error = null;
        state.count.getTaskStatuses = ++state.count.getTaskStatuses;
      })
      .addCase(getTaskStatuses.fulfilled, (state, action) => {
        state.loading = loadStatus.success;
        state.data = action.payload;
        state.count.getTaskStatuses = 0;
      })
      .addCase(getTaskStatuses.rejected, (state, action) => {
        state.loading = loadStatus.error;
        state.error = action.error;
        state.count.getTaskStatuses = 0;
      })
      //Add Task
      .addCase(addTaskStatuses.pending, (state) => {
        state.loading = loadStatus.loading;
        state.error = null;
      })
      .addCase(addTaskStatuses.fulfilled, (state, action) => {
        state.loading = loadStatus.success;
        state.data.unshift(action.payload);
      })
      .addCase(addTaskStatuses.rejected, (state, action) => {
        state.loading = loadStatus.error;
        state.error = action.error;
      })
      //Update Task
      .addCase(editTaskStatuses.pending, (state) => {
        state.loading = loadStatus.loading;
        state.error = null;
      })
      .addCase(editTaskStatuses.fulfilled, (state, action) => {
        state.loading = loadStatus.success;
        const index = state.data.findIndex(
          (item) => (item.id = action.payload.id)
        );
        if (index !== -1) {
          state.data[index] = action.payload;
        }
      })
      .addCase(editTaskStatuses.rejected, (state, action) => {
        state.loading = loadStatus.error;
        state.error = action.error;
      })
      //Delete Task
      .addCase(deleteTaskStatuses.pending, (state) => {
        state.loading = loadStatus.loading;
        state.error = null;
      })
      .addCase(deleteTaskStatuses.fulfilled, (state, action) => {
        state.loading = loadStatus.success;
        state.data.filter((item) => item.id !== action.meta.arg.id);
      })
      .addCase(deleteTaskStatuses.rejected, (state, action) => {
        state.loading = loadStatus.error;
        state.error = action.error;
      });
  },
});

export const { setTaskStatuses, setSelectedTaskStatuses, unsetTaskStatuses } =
  taskStatusesSlice.actions;
export default taskStatusesSlice.reducer;
